import { reqIntercept } from "./reqIntercept";

const API_URL = process.env.REACT_APP_API_URL;

// helper function to fetch data
// url, method, body, contentType are the parameters
const fetchMachineService = () => {
	// pass data through intercepter to add auth header
	const get = (url) => {
		return reqIntercept(url, "GET");
	};

	const post = (url, body, contentType) => {
		return reqIntercept(url, "POST", body, (contentType = "application/json"));
	};

	// logout goes through the interceptor too, so the access-token refresh/retry
	// is handled centrally instead of separately on the logout page
	const logout = (refreshToken) => {
		return reqIntercept(API_URL + "/logout", "POST", { refreshToken });
	};

	return { get, post, logout };
};

export const fetchMachine = fetchMachineService();

export default fetchMachine;
